import { setCookie, destroyCookie, getCookie } from 'utils/cookies';

import SETTINGS from '../settings';

const CountryCodeCookie = {
  get: (ctx = null) => {
    const value = getCookie(ctx, SETTINGS.COOKIE_COUNTRY_CODE_NAME);
    if (value) {
      if (value.length === 2) {
        return value;
      }
    }
    return undefined;
  },

  set: (realCountryCode, ctx = null) => {
    setCookie(
      ctx,
      SETTINGS.COOKIE_COUNTRY_CODE_NAME,
      realCountryCode,
      SETTINGS.COOKIE_COUNTRY_CODE_OPTIONS,
    );
  },

  destroy: (ctx = null) => {
    destroyCookie(ctx, SETTINGS.COOKIE_COUNTRY_CODE_NAME);
  },
};

export default CountryCodeCookie;
